import { logger } from "../default-logger";
import { Typography } from "@mui/material";
/**
 * Parses html strings into the corresponding MUI Typography component
 * Currently supported tags:
 * - <br> -> injects newlines
 * @param {String} htmlString 
 * @returns 
 */
export function htmlToTypography(htmlString) {
  // match <br> tags, in any format, accounting for potential spacing and case variations (e.g. <br>, <br/>, <br    />, <BR/>)
  const lines = htmlString
    .split(/<br\s*\/?>/i) 
    .map(line => line.trim())
    .filter(Boolean);

  // logger.debug('html start', htmlString, lines)

  return lines.map((line, i) => (
    <Typography key={i} variant="inherit" display="block" color={'inherit'} fontSize={'inherit'} textTransform={'inherit'}>
      {line}
    </Typography>
  ));
}